// The stored roles that work in the admin area (J/authority/Permission): an admin, or a team member
// with fewer rights. Their home is the admin dashboard. Kept apart from authUtils so the many tests
// that mock authUtils still get the real list.
export const STAFF_ROLES = ['ADMIN', 'TEAM'];
export const isStaffRole = (role) => STAFF_ROLES.includes(role);
